exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-signup .condition[data-v-80ab0d5a]  .yxt-form-item__content{line-height:22px !important}\n", ""]);

